import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d28673ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "following profile-content" }
const _hoisted_2 = { class: "content__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "content__title" }, "Following", -1))
const _hoisted_4 = { class: "content__count" }
const _hoisted_5 = { class: "content__main" }
const _hoisted_6 = {
  key: 0,
  class: "content__loading"
}
const _hoisted_7 = {
  key: 1,
  class: "starred__list content__list"
}

import { useStore } from "vuex";
import { computed, onMounted } from "vue";
import Spinner from "@/components/Spinner/Spinner.vue";
import FollowingItem from "@/components/FollowingItem/FollowingItem.vue";


export default /*#__PURE__*/_defineComponent({
  name: 'followingPage',
  setup(__props) {

const store = useStore();

const user = computed(() => store.state.auth.user);
const following = computed(() => store.state.profile.following);
const unfollow = (login) => {
  store.dispatch("profile/unFollow", login);
};

onMounted(() => {
  if (user.value === null) {
    store.dispatch("auth/getUserData");
  }
  if (following.value === null) {
    store.dispatch("profile/getUserFollowing");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(following)?.length), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_unref(following) === null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(Spinner)
          ]))
        : (_openBlock(), _createElementBlock("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(following), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "starred__item",
                key: item.id
              }, [
                _createVNode(FollowingItem, {
                  username: item.login,
                  userType: item.type,
                  avatarUrl: item.avatar_url,
                  onUnfollow: ($event: any) => (unfollow(item.login))
                }, null, 8, ["username", "userType", "avatarUrl", "onUnfollow"])
              ]))
            }), 128))
          ]))
    ])
  ]))
}
}

})